import { useCallback, useEffect, useRef, useState } from "react";
import { ApiMember } from "../../pages/manageMembers/models/ManageMemberModel";
import { getMemberGuide, updateMemberGuide } from "../../services/membersAdminService";

export const useMemberGuide = (userId?: number) => {
    const isMoutedRef = useRef(true);
    const [loading, setLoading] = useState(false);
    const [memberGuide, setMemberGuide] = useState<ApiMember | null>(null);

    useEffect(() => {
        isMoutedRef.current = true;
        return () => {
            isMoutedRef.current = false;
        }
    });

    const load = useCallback(async (reset: boolean = true) => {
        if(loading || !userId)
            return;
        try {
            setLoading(true);
            if(reset)
                setMemberGuide(null);
            const _data: ApiMember = await getMemberGuide(userId);
            if(!isMoutedRef.current)
                return;
            if(_data)
                setMemberGuide(_data);
        }
        finally {
            if(!isMoutedRef.current)
                return;
            setLoading(false);
        }
    }, [userId]);
    
    useEffect(() => {
        load();
    }, [load]);
    
    const set = async (memberGuideId: number | null) => {
        if(loading || !userId)
            return;
        try {
            setLoading(true);
            await updateMemberGuide(userId, memberGuideId);
            await load(false);
        }
        finally {
            if(!isMoutedRef.current)
                return;
            setLoading(false);
        }
    };

    return { loading, memberGuide, updateMemberGuide: set, reloadMemberGuide: load };
}